var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppointmentsUnconfirmed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#febe10;}.cls-2{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:90px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_184_copy",
    "data-name": "Layer 184 copy"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 300.78,
    cy: 299.36,
    r: 299.73,
    transform: "translate(-123.58 300.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "152.88 301.73 270.62 404.42 443.77 192.31"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentsUnconfirmed);
export default __webpack_public_path__ + "static/media/appointments_unconfirmed.24c55543109d97ced56a1fe595c1b1b4.svg";
export { ForwardRef as ReactComponent };